// selectActiveBuilding — pick the "default" building + its floors out of a
// FloorStackResponse. Pulled out of FloorStackContainer so it can be unit
// tested without a DOM, and so the React component can call it inside a
// useMemo that runs unconditionally (even while data is still loading) —
// otherwise the selector lived after early-return branches and produced
// React error #310 (hook order changed across renders).

import type { FloorStackResponse, BuildingFloorDto, FloorStatusSnapshotDto } from "../lib/floorStackApi.js";

export type ActiveFloor = BuildingFloorDto & { latest_snapshot: FloorStatusSnapshotDto | null };

export interface ActiveBuilding {
  building: FloorStackResponse["buildings"][number];
  floors: ActiveFloor[];
}

export function selectActiveBuilding(
  data: FloorStackResponse | null,
  /** Operator-chosen building id (e.g. picked from the aerial view's
   *  building list). Wins over `default_building_id` when set + valid. */
  overrideId: string | null = null,
): ActiveBuilding | null {
  if (!data) return null;
  if (data.buildings.length === 0) return null;
  const overridden = overrideId ? data.buildings.find((b) => b.id === overrideId) : undefined;
  const want = data.site.default_building_id;
  const building = overridden
    ?? (want ? data.buildings.find((b) => b.id === want) : undefined)
    ?? data.buildings[0];
  return { building, floors: building.floors };
}
